import { defineMessages } from 'react-intl'

export const brandMessages = defineMessages({
  whatsGymaholic: {
    id: 'whatsGymaholic',
    defaultMessage: 'What’s Gymaholic?'
  },
  moveEatAndLiveBetter: {
    id: 'moveEatAndLiveBetter',
    defaultMessage: 'Our mission is to empower people to move, eat and live better.'
  },
  gymaholicDescription: {
    id: 'gymaholicDescription',
    defaultMessage: 'Gymaholic is a fitness app that lets you log meals in seconds with AI and follow personalized workout plans built for your goals. Track nutrition and workouts together in one app to stay consistent and see results.'
  }
})
